<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
      size="lg"
      class="basic-modal-color"
    >   
      <CRow>      
        <CCol md="12">
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="guests"
            :fields="fields"
            :dark="dark"
          >           
          <template #position="{item}"><td class="text-center">{{item.position}}</td></template>
            <template #date="{item}">
              <td class="text-center">
                {{item.date | date}}                
              </td>
            </template>           
          </CDataTable>        
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cerrar</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'HistoryInvitationModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°'},
          {key: 'date', label: 'Fecha'},
          // {key: 'is_confirm', label: 'Confirmación'},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Historial Invitaciones",
      color: "info",
      submitted: false,      
      guests: [],      
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async showHistoryModal (guest_id) {
      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Historial Invitaciones';
        this.isEdit = false;
        this.submitted = false;
      
        let response = await ws.getHistory({id: guest_id});
        if(response.type == "success"){
          this.guests = response.data;
        }
      this.loaded();

    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
    },
    getEmptyForm () {
      return {
          id: 0,
      }
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>